module.exports = __webpack_public_path__ + "static/pink-floyd-carousel-d4cef623f09f49314719fb5af668fe96.jpg";